<template>
    <div>
        <TheBeatTape v-if="beatTape" :beat-tape="beatTape" :beat-tape-playlist="beatTapePlaylist" />
    </div>
</template>

<script>
import Configure from "./../../mixins/configure";
import TheBeatTape from "../beat-tapes/TheBeatTape";

import BeatTapesRepository from "./../../mixins/beat-tapes-repository";
import BeatTape from "../../models/beat-tapes";
import Beat from "../../models/beat";
import Playlist from './../../classes/playlist'

export default {
  beforeRouteUpdate (to, from, next) {
      this.getBeatTape(to.params.beatTape);
      next()
  },
  created() {

      if (this.$route.params.beatTape == undefined) {
          this.$router.push({ path: "/" });
      }
      this.getBeatTape(this.$route.params.beatTape);
  },
  components: {
      TheBeatTape
  },
  data() {
      return {
            beatTapePlaylist: null,
            beatTape: null
      };
  },
  computed: {
    config() {
        return this.$store.state.currentConfig
    },
    playlistManager() {
        return this.$store.state.playlistManager
    },
    beatTapePlaylistName() {
        if(!this.beatTape) return ""
        return `beat-tapes/playlist/${this.beatTape.id}/`
    }
  },
  mixins: [Configure, BeatTapesRepository],
  methods: {
    getBeatTape(id) {
        this.$store.commit('toggleLoading')


        this.getUserBeatTapeItems(id)
            .then((item) => {

                this.beatTape = new BeatTape(item.data.item);
                this.beatTapePlaylist = item.data.item.items.map(item => new Beat({...item.music_item, license: item.license}))

                if(!this.beatTapePlaylistName) this.$router.push({ path: "/" });

                this.playlistManager.setPagePlaylist(new Playlist(this.beatTapePlaylist, this.beatTapePlaylistName, this.beatTape.id))
            })
            .catch((e) => {
                console.error(e)
                this.$router.push({ path: "/" });
            })
            .finally(() => {
                this.$store.commit('toggleLoading')
            });
    }
  }
};
</script>
